
const SET_DRIVER_TITLE = "SET_DRIVER_TITLE";
const GET_DRIVER_TITLE = "GET_DRIVER_TITLE";

export {
    SET_DRIVER_TITLE,
    GET_DRIVER_TITLE,
};
